// Portfolio Tracker - Frontend Configuration

export const config = {
  // API base URL
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL || '/api/v1',

  // Cognito configuration
  cognito: {
    region: import.meta.env.VITE_COGNITO_REGION || 'us-east-1',
    userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID || '',
    clientId: import.meta.env.VITE_COGNITO_CLIENT_ID || '',
  },

  // Feature flags
  features: {
    authEnabled: Boolean(import.meta.env.VITE_COGNITO_USER_POOL_ID),
  },
}

export default config
